(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
  (function () {
    // Copy link button
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.js-copy-link');
      if (!btn) return;

      const url = btn.dataset.url;
      const label = btn.querySelector('.js-copy-link-text');

      navigator.clipboard.writeText(url).then(() => {
        if (label) label.textContent = 'Copied!';
        setTimeout(() => {
          if (label) label.textContent = 'Copy link';
        }, 2000);
      }).catch(() => {
        // Fallback for older browsers
        const ta = document.createElement('textarea');
        ta.value = url;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        if (label) label.textContent = 'Copied!';
        setTimeout(() => {
          if (label) label.textContent = 'Copy link';
        }, 2000);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  (function () {
    const grid     = document.getElementById('BlogGrid');
    const sentinel = document.getElementById('BlogSentinel');
    const loading  = document.getElementById('BlogLoading');
    const endMsg   = document.getElementById('BlogEnd');

    if (!grid || !sentinel) return;

    let isFetching = false;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting || isFetching) return;

      const nextUrl = grid.dataset.nextUrl;
      if (!nextUrl) {
        observer.disconnect();
        sentinel.remove();
        endMsg?.removeAttribute('aria-hidden');
        return;
      }

      isFetching = true;
      loading?.removeAttribute('aria-hidden');

      fetch(nextUrl)
        .then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('.article-card');
          const newNextUrl = doc.getElementById('BlogGrid')?.dataset.nextUrl || '';

          newItems.forEach((item) => grid.appendChild(item));
          grid.dataset.nextUrl = newNextUrl;

          loading?.setAttribute('aria-hidden', 'true');
          isFetching = false;

          if (!newNextUrl) {
            observer.disconnect();
            sentinel.remove();
            endMsg?.removeAttribute('aria-hidden');
          }
        })
        .catch(() => {
          loading?.setAttribute('aria-hidden', 'true');
          isFetching = false;
        });
    }, { rootMargin: '400px' });

    observer.observe(sentinel);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  const initHeader = () => {
    if (window._headerController) window._headerController.abort();
    window._headerController = new AbortController();
    const { signal } = window._headerController;

    // Catalog two-panel hover
    document.querySelectorAll('.catalog-dd').forEach(dd => {
      const cats   = dd.querySelectorAll('.catalog-dd__cat');
      const panels = dd.querySelectorAll('.catalog-dd__panel');

      cats.forEach(cat => {
        cat.addEventListener('mouseenter', () => {
          const idx = cat.dataset.cat;
          cats.forEach(c => c.classList.remove('is-active'));
          panels.forEach(p => p.classList.remove('is-active'));
          cat.classList.add('is-active');
          dd.querySelector(`.catalog-dd__panel[data-panel="${idx}"]`)?.classList.add('is-active');
        });
      });
    });

    // Brand Filtering Logic
    document.querySelectorAll('.header__brand-tab').forEach(tab => {
       tab.addEventListener('click', (e) => {
         const container = e.target.closest('.header__alpha-content');
         const category = e.target.dataset.category;

         container.querySelectorAll('.header__brand-tab').forEach(t => t.classList.remove('active'));
         e.target.classList.add('active');

         container.querySelectorAll('.header__brand-item').forEach(item => {
           if (category === 'all' || item.dataset.category === category) {
             item.classList.remove('hidden');
           } else {
             item.classList.add('hidden');
           }
         });
       });
    });

    // Dropdown keyboard navigation
    const openDropdown = (trigger, item) => {
      item.classList.add('header__menu-item--open');
      trigger.setAttribute('aria-expanded', 'true');

      if (window.innerWidth < 1024) {
        setTimeout(() => {
          item.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 150);
      }
    };

    const closeDropdown = (trigger, item) => {
      item.classList.remove('header__menu-item--open');
      trigger.setAttribute('aria-expanded', 'false');
    };

    const closeAllDropdowns = () => {
      document.querySelectorAll('.header__menu-item--open').forEach(item => {
        const trigger = item.querySelector('.header__menu-link[aria-expanded]');
        if (trigger) closeDropdown(trigger, item);
      });
    };

    document.querySelectorAll('.header__menu-link[aria-haspopup]').forEach(trigger => {
      const item = trigger.closest('.header__menu-item');

      trigger.addEventListener('keydown', (e) => {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (e.key === 'ArrowDown' || (e.key === ' ' && !isOpen)) {
          e.preventDefault();
          openDropdown(trigger, item);
          const firstFocusable = item.querySelector('.header__dropdown a, .header__dropdown button');
          if (firstFocusable) firstFocusable.focus();
        }

        if (e.key === 'Escape' && isOpen) {
          e.stopPropagation();
          closeDropdown(trigger, item);
          trigger.focus();
        }
      });
    });

    document.addEventListener('click', (e) => {
      if (document.querySelector('.header__menu-item--open') && !e.target.closest('.header__menu-item')) {
        closeAllDropdowns();
      }
    }, { signal });

    // Search Logic
    const searchModal = document.getElementById('SearchModal');
    const searchTriggers = document.querySelectorAll('.header__icon-link--search');
    const searchClose = document.querySelector('.search-modal__close');
    const searchInput = document.getElementById('SearchInput');
    const searchResults = document.getElementById('SearchResults');

    const strings = {
      start: searchModal?.dataset.strStart || 'Start typing to search',
      searching: searchModal?.dataset.strSearching || 'Searching...',
      noResults: searchModal?.dataset.strNoResults || 'No results found',
      error: searchModal?.dataset.strError || 'Search unavailable. Please try again.',
      products: searchModal?.dataset.strProducts || 'Products',
      collections: searchModal?.dataset.strCollections || 'Collections',
    };

    const openSearch = () => {
      searchModal.classList.add('search-modal--active');
      searchModal.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      setTimeout(() => searchInput.focus(), 100);
    };

    const closeSearch = () => {
      searchModal.classList.remove('search-modal--active');
      searchModal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      searchInput.value = '';
      searchResults.innerHTML = emptyState(strings.start);
      // No single searchTrigger focus to avoid confusion
    };

    // Mobile navigation — single drill-down panel (MobileSubmenu)
    const hamburger = document.querySelector('.header__icon-link--menu');
    const mobileNav = document.getElementById('MobileNav');
    const mobileOverlay = document.getElementById('MobileNavOverlay');
    const mobileSubmenu = document.getElementById('MobileSubmenu');
    const mobileSubmenuTitle = document.getElementById('MobileSubmenuTitle');
    const mobileSubmenuBody = document.getElementById('MobileSubmenuBody');
    const mobileSubmenuBack = document.getElementById('MobileSubmenuBack');

    let menuLevel = 0;

    const buildMainMenuHTML = () => {
      const items = mobileNav ? Array.from(mobileNav.querySelectorAll('.header__menu > .header__menu-item')) : [];
      let html = '<ul class="mobile-main-list">';
      items.forEach((item, idx) => {
        const link = item.querySelector('.header__menu-link');
        const text = link?.querySelector('.header__menu-text')?.textContent?.trim() || link?.textContent?.trim() || '';
        const href = link?.getAttribute('href') || '#';
        const hasDropdown = !!item.querySelector('.header__dropdown');
        if (hasDropdown) {
          html += `<li class="mobile-main-item"><button class="mobile-main-trigger" data-idx="${idx}">${escHtml(text)}<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 18 6-6-6-6"/></svg></button></li>`;
        } else {
          html += `<li class="mobile-main-item"><a href="${escHtml(href)}" class="mobile-main-link">${escHtml(text)}</a></li>`;
        }
      });
      html += '</ul>';
      return html;
    };

    const showMainMenu = () => {
      menuLevel = 0;
      if (mobileSubmenuBack) mobileSubmenuBack.style.visibility = 'hidden';
      if (mobileSubmenuTitle) mobileSubmenuTitle.textContent = '';
      if (mobileSubmenuBody) {
        mobileSubmenuBody.innerHTML = buildMainMenuHTML();
        mobileSubmenuBody.querySelectorAll('.mobile-main-trigger').forEach(btn => {
          btn.addEventListener('click', () => {
            const idx = parseInt(btn.dataset.idx);
            const items = mobileNav ? Array.from(mobileNav.querySelectorAll('.header__menu > .header__menu-item')) : [];
            const item = items[idx];
            const dropdown = item?.querySelector('.header__dropdown');
            const title = btn.childNodes[0]?.textContent?.trim() || '';
            if (dropdown && title) showSubMenu(title, dropdown);
          });
        });
      }
    };

    const showSubMenu = (title, dropdown) => {
      menuLevel = 1;
      if (mobileSubmenuBack) mobileSubmenuBack.style.visibility = 'visible';
      if (mobileSubmenuTitle) mobileSubmenuTitle.textContent = title;
      if (mobileSubmenuBody) mobileSubmenuBody.innerHTML = dropdown.innerHTML;
    };

    const openMobileMenu = () => {
      if (!mobileSubmenu) return;
      showMainMenu();
      mobileSubmenu.classList.add('is-open');
      mobileSubmenu.removeAttribute('aria-hidden');
      mobileOverlay?.classList.add('is-visible');
      mobileOverlay?.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      hamburger?.setAttribute('aria-expanded', 'true');
      hamburger?.setAttribute('aria-label', hamburger?.dataset.labelClose || 'Close menu');
    };

    const closeMobileMenu = () => {
      if (!mobileSubmenu) return;
      mobileSubmenu.classList.remove('is-open');
      mobileSubmenu.setAttribute('aria-hidden', 'true');
      mobileOverlay?.classList.remove('is-visible');
      mobileOverlay?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      hamburger?.setAttribute('aria-expanded', 'false');
      hamburger?.setAttribute('aria-label', hamburger?.dataset.labelOpen || 'Open menu');
    };

    hamburger?.addEventListener('click', () => {
      mobileSubmenu?.classList.contains('is-open') ? closeMobileMenu() : openMobileMenu();
    }, { signal });

    mobileOverlay?.addEventListener('click', closeMobileMenu, { signal });
    document.getElementById('MobileNavClose')?.addEventListener('click', closeMobileMenu, { signal });
    mobileSubmenuBack?.addEventListener('click', () => {
      menuLevel > 0 ? showMainMenu() : closeMobileMenu();
    }, { signal });
    document.getElementById('MobileSubmenuClose')?.addEventListener('click', closeMobileMenu, { signal });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 1024 && mobileSubmenu?.classList.contains('is-open')) {
        closeMobileMenu();
      }
    }, { passive: true, signal });

    searchTriggers.forEach(trigger => trigger.addEventListener('click', openSearch));
    searchClose?.addEventListener('click', closeSearch);
    document.querySelector('.search-modal__overlay')?.addEventListener('click', closeSearch);

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && searchModal.classList.contains('search-modal--active')) closeSearch();
    }, { signal });

    const escHtml = (str) => String(str ?? '').replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');

    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      const locale = document.documentElement.lang || 'en';
      try {
        return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(parseInt(cents, 10));
      } catch (_) {
        return String(cents);
      }
    };

    const emptyState = (msg) => `<div class="search-modal__empty-state"><p>${escHtml(msg)}</p></div>`;

    let debounceTimer;
    let fetchController = null;
    searchInput?.addEventListener('input', (e) => {
      const query = e.target.value.trim();
      clearTimeout(debounceTimer);
      if (fetchController) { fetchController.abort(); fetchController = null; }

      if (query.length < 2) {
        searchResults.innerHTML = emptyState(strings.start);
        return;
      }

      searchResults.innerHTML = emptyState(strings.searching);

      debounceTimer = setTimeout(() => {
        fetchController = new AbortController();
        fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection,page&resources[limit]=5&resources[options][unavailable_products]=last`, { signal: fetchController.signal })
          .then(res => {
            if (!res.ok) throw new Error(res.status);
            return res.json();
          })
          .then(data => {
            const products = data.resources.results.products || [];
            const collections = data.resources.results.collections || [];

            if (products.length === 0 && collections.length === 0) {
              searchResults.innerHTML = emptyState(strings.noResults) + `<a href="/search?q=${encodeURIComponent(query)}&type=product" class="predictive-search__view-all"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>Search for &ldquo;${escHtml(query)}&rdquo;</a>`;
              return;
            }

            let html = '<div class="predictive-search__list">';

            if (products.length > 0) {
              html += `<div class="predictive-search__section-title">${escHtml(strings.products)}</div>`;
              products.forEach(product => {
                const img = product.image ? `<img src="${escHtml(product.image)}" class="predictive-search__image" loading="lazy" alt="${escHtml(product.title)}">` : '';
                html += `<a href="${escHtml(product.url)}" class="predictive-search__item"><div class="predictive-search__image-wrapper">${img}</div><div class="predictive-search__info"><h4 class="predictive-search__title">${escHtml(product.title)}</h4><span class="predictive-search__price">${escHtml(formatMoney(product.price))}</span></div></a>`;
              });
            }

            if (collections.length > 0) {
              html += `<div class="predictive-search__section-title">${escHtml(strings.collections)}</div>`;
              collections.forEach(collection => {
                html += `<a href="${escHtml(collection.url)}" class="predictive-search__item"><div class="predictive-search__info"><h4 class="predictive-search__title">${escHtml(collection.title)}</h4></div></a>`;
              });
            }

            html += '</div>';
            html += `<a href="/search?q=${encodeURIComponent(query)}&type=product" class="predictive-search__view-all"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide" aria-hidden="true"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.3-4.3"/></svg>Search for &ldquo;${escHtml(query)}&rdquo;</a>`;
            searchResults.innerHTML = html;
          })
          .catch((err) => {
            if (err.name === 'AbortError') return;
            searchResults.innerHTML = emptyState(strings.error);
          });
      }, 300);
    });
  };


  // Global Add-to-Cart Interceptor (Singleton)
  if (!window.cartInterceptorAdded) {
    document.addEventListener('submit', async (e) => {
      const form = e.target;
      const action = form.getAttribute('action');
      
      if (action && (action.includes('/cart/add') || form.querySelector('[name="id"]'))) {
        // Double check it's a product form
        if (!form.querySelector('[name="id"]')) return;
        
        e.preventDefault();
        const formData = new FormData(form);
        
        try {
          const sectionId = document.querySelector('.header[data-section-id]')?.dataset.sectionId;
          if (sectionId) formData.append('sections', sectionId);
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            body: formData
          });
          
          const data = await res.json();
          
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:updated', { 
              detail: { 
                cart: data,
                sections: data.sections
              } 
            }));
            
            if (window.showToast) {
              const headerEl = document.querySelector('.header[data-str-item-added]');
            window.showToast(headerEl?.dataset.strItemAdded || 'Item added to cart', 'shopping-cart');
            }
          }
        } catch (_) {
        }
      }
    });
    window.cartInterceptorAdded = true;
  }


  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
  });

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.header')) {
       initHeader();
    }
  });

  /* ── Lecture category nav dropdowns ─────────────────────────────────── */
  (function() {
    var catSel    = document.getElementById('header-lf-cat');
    var subSel    = document.getElementById('header-lf-sub');
    var subPill   = document.getElementById('header-lf-sub-pill');
    if (!catSel || !subSel) return;

    function populateCats() {
      if (!window.OP_CATEGORIES) return;
      while (catSel.options.length > 1) catSel.remove(1);
      Object.entries(window.OP_CATEGORIES).forEach(function(entry) {
        catSel.appendChild(new Option(entry[1].label, entry[0]));
      });
    }

    function populateSubs(catKey) {
      while (subSel.options.length > 1) subSel.remove(1);
      if (!catKey || !window.OP_CATEGORIES || !window.OP_CATEGORIES[catKey]) {
        subPill.style.display = 'none';
        return;
      }
      subPill.style.display = 'flex';
      window.OP_CATEGORIES[catKey].subs.forEach(function(s) {
        subSel.appendChild(new Option(s.label, s.key));
      });
    }

    function syncFromStorage() {
      if (!window.OP_CATEGORIES) return;
      populateCats();
      var catKey = localStorage.getItem('op_cat') || '';
      var subKey = localStorage.getItem('op_sub') || '';
      catSel.value = catKey;
      populateSubs(catKey);
      if (subKey) subSel.value = subKey;
    }

    catSel.addEventListener('change', function() {
      var catKey = this.value;
      populateSubs(catKey);
      localStorage.setItem('op_cat', catKey);
      localStorage.setItem('op_sub', '');
      document.dispatchEvent(new CustomEvent('op:selection', { detail: { cat: catKey, sub: '' } }));
    });

    subSel.addEventListener('change', function() {
      var catKey = catSel.value;
      var subKey = this.value;
      localStorage.setItem('op_sub', subKey);
      document.dispatchEvent(new CustomEvent('op:selection', { detail: { cat: catKey, sub: subKey } }));
    });

    /* Keep header selects in sync when popup makes a selection */
    document.addEventListener('op:selection', function(e) {
      var cat = e.detail.cat;
      var sub = e.detail.sub;
      /* Skip if we dispatched it ourselves (value already set) */
      if (catSel.value === cat && subSel.value === sub) return;
      if (!window.OP_CATEGORIES) return;
      populateCats();
      catSel.value = cat;
      populateSubs(cat);
      if (sub) subSel.value = sub;
    });

    if (window.OP_CATEGORIES) {
      syncFromStorage();
    } else {
      document.addEventListener('op:ready', syncFromStorage, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-lectures-trigger]').forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      if (window.OPPopup) {
        window.OPPopup.open();
      } else {
        document.addEventListener('op:ready', function() { window.OPPopup.open(); }, { once: true });
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lectures-catalog"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function initLecturesCatalog(section) {
      if (section.dataset.lcInitialized === 'true') return;
      section.dataset.lcInitialized = 'true';

      const grid      = section.querySelector('[id^="lc-grid-"]');
      const moreBtn   = section.querySelector('[id^="lc-more-"]');
      const noResults = section.querySelector('.lectures-catalog__no-results');
      if (!grid) return;

      const defaultCount = parseInt(grid.dataset.defaultCount, 10) || 8;
      const allCards = Array.from(grid.querySelectorAll('.lc-card-wrap'));
      let showCount = defaultCount;

      /* ── Field roles ────────────────────────────────────────────────── */
      const catField     = section.querySelector('[data-filter-type="category"]');
      const levelField   = section.querySelector('[data-filter-type="level"]');
      const subjectField = section.querySelector('[data-filter-type="subject"]');
      const facultyField = section.querySelector('[data-filter-type="faculty"]');
      const searchField  = section.querySelector('[data-filter-type="search"]');
      const tagFields    = Array.from(section.querySelectorAll('[data-filter-type="tag"]'));

      const allowedCats = () => ['ca', 'cma', 'cs'];

      const splitVals = str => (str || '').toLowerCase().split(',').map(s => s.trim()).filter(Boolean);

      /* Product data carries the level in two spellings — abbreviated ("CA Inter") and full
         ("CA Intermediate") — the same split that made the plain vs `_n` subject/faculty
         metafields necessary. Expand a taxonomy tag to both forms so either one matches. */
      const tagVariants = tag => {
        const t = (tag || '').toLowerCase().trim();
        if (!t) return [];
        if (/\binter\b/.test(t))        return [t, t.replace(/\binter\b/, 'intermediate')];
        if (/\bintermediate\b/.test(t)) return [t, t.replace(/\bintermediate\b/, 'inter')];
        return [t];
      };
      const cardHasTag = (cardTagArr, tag) => tagVariants(tag).some(v => cardTagArr.includes(v));

      const currentCatObj = () => {
        const key = catField ? catField.value : '';
        return key && allowedCats().includes(key) ? window.OP_CATEGORIES?.[key] : null;
      };
      const currentLevelObj = () => {
        const cat = currentCatObj();
        const key = levelField ? levelField.value : '';
        return key && cat ? cat.subs.find(s => s.key === key) : null;
      };

      const cardTagList = card => (card.dataset.tags || '').toLowerCase().split('|').map(t => t.trim());
      const cardCollList = card => (card.dataset.collections || '').toLowerCase().split('|').map(c => c.trim());

      /* Match how the rest of the site groups levels: by collection membership (the same
         `collection` handle the nav mega-menu and footer link to, e.g. "ca-inter"), falling
         back to the level tag when a sub has no collection mapped. This avoids relying on a
         product tag string that isn't consistent across levels. */
      const subMatchesCard = (sub, cardTagArr, cardCollArr) => {
        if (!sub) return false;
        if (sub.collection && cardCollArr.includes(sub.collection.toLowerCase())) return true;
        return cardHasTag(cardTagArr, sub.tag);
      };
      /* A Category selection matches its own tag, or any of its levels (by collection or tag). */
      const catMatchesCard = (catObj, cardTagArr, cardCollArr) => {
        if (!catObj) return false;
        if (cardHasTag(cardTagArr, catObj.tag)) return true;
        return catObj.subs.some(s => subMatchesCard(s, cardTagArr, cardCollArr));
      };

      /* Cards matching only the Category + Level taxonomy filters (used to scope Subject/Faculty options) */
      const cardsInScope = () => {
        const catObj   = currentCatObj();
        const levelObj = currentLevelObj();
        if (!catObj && !levelObj) return allCards;
        return allCards.filter(card => {
          const cardTagArr  = cardTagList(card);
          const cardCollArr = cardCollList(card);
          if (catObj && !catMatchesCard(catObj, cardTagArr, cardCollArr)) return false;
          if (levelObj && !subMatchesCard(levelObj, cardTagArr, cardCollArr)) return false;
          return true;
        });
      };

      const collectUnique = (cards, attr) => {
        const seen = new Map();
        cards.forEach(card => {
          (card.dataset[attr] || '').split(',').forEach(tok => {
            const t = tok.trim();
            if (t && !seen.has(t.toLowerCase())) seen.set(t.toLowerCase(), t);
          });
        });
        return Array.from(seen.entries()).sort((a, b) => a[1].localeCompare(b[1]));
      };

      const populateSelect = (select, entries) => {
        if (!select) return;
        const keep = entries.some(([key]) => key === select.value) ? select.value : '';
        select.innerHTML = '';
        select.appendChild(new Option(select.dataset.placeholder || '', ''));
        entries.forEach(([key, label]) => select.appendChild(new Option(label, key)));
        select.value = keep;
      };

      function populateCategory() {
        if (!catField || !window.OP_CATEGORIES) return;
        const keep = catField.value;
        catField.innerHTML = '';
        catField.appendChild(new Option(catField.dataset.placeholder || '', ''));
        allowedCats().forEach(key => {
          const cat = window.OP_CATEGORIES[key];
          if (cat) catField.appendChild(new Option(cat.label, key));
        });
        catField.value = allowedCats().includes(keep) ? keep : '';
      }

      function populateLevel() {
        if (!levelField) return;
        const cat = currentCatObj();
        levelField.innerHTML = '';
        levelField.appendChild(new Option(levelField.dataset.placeholder || '', ''));
        if (cat) {
          cat.subs.forEach(s => levelField.appendChild(new Option(s.label, s.key)));
          levelField.disabled = false;
        } else {
          levelField.disabled = true;
        }
      }

      function refreshSubjectFaculty() {
        const scoped = cardsInScope();
        populateSelect(subjectField, collectUnique(scoped, 'compareSubject'));

        let facultyScope = scoped;
        if (subjectField && subjectField.value) {
          facultyScope = scoped.filter(card => splitVals(card.dataset.compareSubject).includes(subjectField.value.toLowerCase()));
        }
        populateSelect(facultyField, collectUnique(facultyScope, 'compareFaculty'));
      }

      const render = () => {
        const catObj     = currentCatObj();
        const levelObj   = currentLevelObj();
        const subjectVal = subjectField ? subjectField.value.toLowerCase() : '';
        const facultyVal = facultyField ? facultyField.value.toLowerCase() : '';
        const searchTerm = searchField ? searchField.value.trim().toLowerCase() : '';
        const tagFilters = tagFields.map(f => f.value.trim().toLowerCase()).filter(Boolean);

        const isFiltering = !!(catObj || levelObj || subjectVal || facultyVal || searchTerm || tagFilters.length);
        let matchCount = 0;

        allCards.forEach((card, i) => {
          const cardTagArr  = cardTagList(card);
          const cardCollArr = cardCollList(card);
          const cardTitle  = (card.dataset.title || '').toLowerCase();
          const catMatch     = !catObj || catMatchesCard(catObj, cardTagArr, cardCollArr);
          const levelMatch   = !levelObj || subMatchesCard(levelObj, cardTagArr, cardCollArr);
          const subjectMatch = !subjectVal || splitVals(card.dataset.compareSubject).includes(subjectVal);
          const facultyMatch = !facultyVal || splitVals(card.dataset.compareFaculty).includes(facultyVal);
          const tagMatch      = tagFilters.every(t => cardTagArr.includes(t));
          const searchMatch   = !searchTerm || cardTitle.includes(searchTerm);
          const matches = catMatch && levelMatch && subjectMatch && facultyMatch && tagMatch && searchMatch;

          // When filtering: show all matches. When not: show only first showCount.
          const show = isFiltering ? matches : (matches && i < showCount);
          card.style.display = show ? '' : 'none';
          if (matches) matchCount++;
        });

        if (moreBtn) {
          moreBtn.style.display = (!isFiltering && allCards.length > showCount) ? '' : 'none';
        }

        if (noResults) {
          noResults.style.display = (isFiltering && matchCount === 0) ? '' : 'none';
        }
      };

      if (moreBtn) {
        moreBtn.addEventListener('click', () => {
          showCount += defaultCount;
          render();
        });
      }

      if (catField) {
        catField.addEventListener('change', () => {
          if (levelField) levelField.value = '';
          populateLevel();
          refreshSubjectFaculty();
          localStorage.setItem('op_cat', catField.value);
          localStorage.setItem('op_sub', '');
          showCount = defaultCount;
          render();
        });
      }

      if (levelField) {
        levelField.addEventListener('change', () => {
          refreshSubjectFaculty();
          localStorage.setItem('op_sub', levelField.value);
          showCount = defaultCount;
          render();
        });
      }

      if (subjectField) {
        subjectField.addEventListener('change', () => {
          refreshSubjectFaculty();
          showCount = defaultCount;
          render();
        });
      }

      if (facultyField) {
        facultyField.addEventListener('change', () => {
          showCount = defaultCount;
          render();
        });
      }

      if (searchField) {
        searchField.addEventListener('input', () => {
          showCount = defaultCount;
          render();
        });
      }

      tagFields.forEach(f => {
        const evt = f.tagName === 'SELECT' ? 'change' : 'input';
        f.addEventListener(evt, () => {
          showCount = defaultCount;
          render();
        });
      });

      /* Listen for selections made in the global exam-category popup elsewhere on the site */
      document.addEventListener('op:selection', (e) => {
        const { cat, sub } = e.detail || {};
        if (!catField || (cat && !allowedCats().includes(cat))) return;
        populateCategory();
        catField.value = cat || '';
        populateLevel();
        if (levelField) levelField.value = sub || '';
        refreshSubjectFaculty();
        showCount = defaultCount;
        render();
      });

      /* Initial paint: Subject/Faculty/Search/static filters work immediately,
         independent of the OP_CATEGORIES taxonomy load. */
      populateLevel();
      refreshSubjectFaculty();
      render();

      /* Category/Level need the OP_CATEGORIES taxonomy (loaded by the global popup section) */
      function initTaxonomy() {
        if (!catField) return;
        populateCategory();
        const savedCat = localStorage.getItem('op_cat') || '';
        const savedSub = localStorage.getItem('op_sub') || '';
        if (allowedCats().includes(savedCat) && window.OP_CATEGORIES[savedCat]) {
          catField.value = savedCat;
          populateLevel();
          if (levelField) levelField.value = savedSub;
          refreshSubjectFaculty();
          showCount = defaultCount;
          render();
        }
      }

      if (window.OP_CATEGORIES) {
        initTaxonomy();
      } else {
        document.addEventListener('op:ready', initTaxonomy, { once: true });
      }
    }

    document.querySelectorAll('.lectures-catalog').forEach(initLecturesCatalog);

    /* Re-init when the theme editor swaps this section's markup (e.g. after changing a
       block setting like Field type) — otherwise the freshly rendered filters never get wired up. */
    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.lectures-catalog') || (e.target.matches?.('.lectures-catalog') ? e.target : null);
      if (section) initLecturesCatalog(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  const initCart = () => {
    const cartSection = document.querySelector('.cart-items-section');
    if (!cartSection) return;

    const sectionId = cartSection.dataset.id;

    const refreshCart = async () => {
      cartSection.classList.add('is-loading');
      
      try {
        const response = await fetch(`${window.location.pathname}?section_id=${sectionId}`);
        const html = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newSection = doc.querySelector('.cart-items-section');
        
        if (newSection) {
          cartSection.innerHTML = newSection.innerHTML;
          // Re-attach listeners
          attachListeners();
        }

        // Also refresh Cart Drawer if globally available
        if (window.refreshCartDrawer) {
          window.refreshCartDrawer();
        }
      } catch (err) {
        console.error('Cart refresh failed', err);
      } finally {
        cartSection.classList.remove('is-loading');
      }
    };

    const updateQuantity = async (id, quantity) => {
      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id, quantity })
        });
        
        if (response.ok) {
          await refreshCart();
          if (window.showToast) {
            window.showToast('Cart updated', 'check-circle');
          }
        }
      } catch (err) {
        console.error('Quantity update failed', err);
      }
    };

    const attachListeners = () => {
      cartSection.querySelectorAll('.quantity-button').forEach(btn => {
        btn.addEventListener('click', () => {
          const id = btn.dataset.id;
          const isPlus = btn.dataset.action === 'plus';
          const input = btn.parentElement.querySelector('input');
          let val = parseInt(input.value);
          const newVal = isPlus ? val + 1 : Math.max(0, val - 1);
          updateQuantity(id, newVal);
        });
      });

      cartSection.querySelectorAll('.cart-item__remove').forEach(btn => {
        btn.addEventListener('click', () => {
          updateQuantity(btn.dataset.id, 0);
        });
      });
    };

    attachListeners();
  };

  document.addEventListener('DOMContentLoaded', initCart);
  document.addEventListener('shopify:section:load', initCart);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"] && !Shopify.designMode) return;
  try {
    
  // ── Helpers ───────────────────────────────────────────

  // Sold out sorting logic — commented out.
  // Re-sorts grid items after dynamic updates so in-stock items appear before sold-out ones.
  // const sortGrid = (g) => {
  //   const items = Array.from(g.querySelectorAll(':scope > .collection-grid__item'));
  //   const inStock  = items.filter(i => i.dataset.available !== 'false');
  //   const outStock = items.filter(i => i.dataset.available === 'false');
  //   [...inStock, ...outStock].forEach(item => g.appendChild(item));
  // };

  // ── Price sliders ─────────────────────────────────────

  const initPriceSliders = (ctx) => {
    ctx.querySelectorAll('.price-slider').forEach((slider) => {
      const minInput   = slider.querySelector('.price-slider__input--min');
      const maxInput   = slider.querySelector('.price-slider__input--max');
      const fill       = slider.querySelector('.price-slider__fill');
      const minDisplay = slider.querySelector('.price-slider__min-display');
      const maxDisplay = slider.querySelector('.price-slider__max-display');
      const hiddenMin  = slider.querySelector('.price-slider__hidden-min');
      const hiddenMax  = slider.querySelector('.price-slider__hidden-max');
      if (!minInput || !maxInput || !fill) return;

      const rangeMin = parseFloat(slider.dataset.min);
      const rangeMax = parseFloat(slider.dataset.max);

      const updateFill = (activeInput) => {
        let lo = parseFloat(minInput.value);
        let hi = parseFloat(maxInput.value);
        if (lo > hi) {
          if (activeInput === minInput) { lo = hi; minInput.value = lo; }
          else { hi = lo; maxInput.value = hi; }
        }
        const loPct = ((lo - rangeMin) / (rangeMax - rangeMin)) * 100;
        const hiPct = ((hi - rangeMin) / (rangeMax - rangeMin)) * 100;
        fill.style.left  = loPct + '%';
        fill.style.width = (hiPct - loPct) + '%';
        if (minDisplay) minDisplay.textContent = Math.round(lo);
        if (maxDisplay) maxDisplay.textContent = Math.round(hi);
        if (hiddenMin)  hiddenMin.value = Math.round(lo);
        if (hiddenMax)  hiddenMax.value = Math.round(hi);
      };

      minInput.addEventListener('input', () => { minInput.style.zIndex = 4; maxInput.style.zIndex = 3; updateFill(minInput); });
      maxInput.addEventListener('input', () => { maxInput.style.zIndex = 4; minInput.style.zIndex = 3; updateFill(maxInput); });
      updateFill(null);
    });
  };

  // ── Filter accordion ──────────────────────────────────

  const initFilterAccordion = (ctx) => {
    ctx.querySelectorAll('.collection-filter__summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const details = summary.closest('.collection-filter');
        const body    = details.querySelector('.collection-filter__body');
        if (!body) return;
        if (details.open) {
          body.style.height = body.scrollHeight + 'px';
          void body.offsetHeight;
          body.style.height = '0px';
          body.addEventListener('transitionend', () => details.removeAttribute('open'), { once: true });
        } else {
          details.setAttribute('open', '');
          const h = body.scrollHeight;
          body.style.height = '0px';
          void body.offsetHeight;
          body.style.height = h + 'px';
          body.addEventListener('transitionend', () => { body.style.height = 'auto'; }, { once: true });
        }
      });
    });
  };

  // ── Faculty filter search ──────────────────────────────

  const initFacultySearch = (ctx) => {
    ctx.querySelectorAll('.collection-filter__search-input').forEach((input) => {
      input.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase().trim();
        const list = e.target.closest('.collection-filter__body')?.querySelector('.collection-filter__list');
        if (!list) return;

        list.querySelectorAll('li').forEach((li) => {
          const label = li.querySelector('.collection-filter__option-label');
          if (!label) return;
          const text = label.textContent.toLowerCase();
          li.style.display = text.includes(searchTerm) ? '' : 'none';
        });
      });
    });
  };

  // ── Infinite scroll ───────────────────────────────────

  const initInfiniteScroll = () => {
    const grid     = document.getElementById('CollectionGrid');
    const sentinel = document.getElementById('CollectionSentinel');
    const loading  = document.getElementById('CollectionLoading');
    const endMsg   = document.getElementById('CollectionEnd');
    if (!grid || !sentinel) return;

    let isFetching = false;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting || isFetching) return;
      const nextUrl = grid.dataset.nextUrl;
      if (!nextUrl) {
        observer.disconnect();
        sentinel.remove();
        endMsg?.removeAttribute('aria-hidden');
        return;
      }
      isFetching = true;
      loading?.removeAttribute('aria-hidden');
      fetch(nextUrl)
        .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          doc.querySelectorAll('.collection-grid__item').forEach(item => grid.appendChild(item));
          grid.dataset.nextUrl = doc.getElementById('CollectionGrid')?.dataset.nextUrl || '';
          loading?.setAttribute('aria-hidden', 'true');
          isFetching = false;
          if (!grid.dataset.nextUrl) {
            observer.disconnect();
            sentinel.remove();
            endMsg?.removeAttribute('aria-hidden');
          }
        })
        .catch(() => { loading?.setAttribute('aria-hidden', 'true'); isFetching = false; });
    }, { rootMargin: '300px' });

    observer.observe(sentinel);
  };

  // ── Sync hardcoded lecture filter checkboxes from URL ─
  const syncLecFilters = (url) => {
    const params = new URL(url, window.location.href).searchParams;
    const activeTags = params.getAll('filter.p.tag');

    // Sidebar checkboxes
    document.querySelectorAll('.lec-filter__cb').forEach(cb => {
      cb.checked = activeTags.includes(cb.value);
      cb.closest('.collection-filter__option')?.classList.toggle('is-active', cb.checked);
    });

    // Top-bar sort
    const topSort = document.getElementById('TopBarSortBy');
    if (topSort) topSort.value = params.get('sort_by') || '';

    // Top-bar tag selects
    document.querySelectorAll('.coll-topbar-tag-select').forEach(sel => {
      const prefix = sel.dataset.tagPrefix + ':';
      const active = activeTags.find(t => t.startsWith(prefix));
      sel.value = active || '';
    });
  };

  // ── AJAX filter/sort update ───────────────────────────

  const fetchAndUpdate = (url) => {
    const section     = document.querySelector('.collection-page');
    const main        = document.getElementById('CollectionMain');
    const gridOverlay = document.getElementById('CollectionGridOverlay');
    if (!section || !main) return;

    gridOverlay?.classList.add('is-visible');

    fetch(url)
      .then(r => { if (!r.ok) throw new Error(r.status); return r.text(); })
      .then(html => {
        const doc = new DOMParser().parseFromString(html, 'text/html');

        // Products
        const newMain = doc.getElementById('CollectionMain');
        if (newMain) main.innerHTML = newMain.innerHTML;

        // Filter sidebar scroll: handles active chips, group badges, checked state
        const filtersScroll    = document.querySelector('.collection-filters__scroll');
        const newFiltersScroll = doc.querySelector('.collection-filters__scroll');
        if (filtersScroll && newFiltersScroll) {
          filtersScroll.replaceWith(newFiltersScroll);
          initPriceSliders(section);
          initFilterAccordion(section);
          initFacultySearch(section);
          syncLecFilters(url);
        }

        // Subject strip (re-render from server so active states are correct)
        const currentStrip = document.getElementById('CollSubjectStrip');
        const newStrip     = doc.getElementById('CollSubjectStrip');
        if (currentStrip && newStrip) currentStrip.replaceWith(newStrip);

        // Mobile filter toggle badge
        const toggleBadge    = document.querySelector('.collection-filter-toggle__badge');
        const newToggleBadge = doc.querySelector('.collection-filter-toggle__badge');
        const toggleBtn      = document.querySelector('.collection-filter-toggle');
        if (newToggleBadge) {
          if (toggleBadge) toggleBadge.replaceWith(newToggleBadge);
          else toggleBtn?.appendChild(newToggleBadge);
        } else {
          toggleBadge?.remove();
        }

        // Sync sort select value from URL
        const urlSort = new URL(url, window.location.href).searchParams.get('sort_by');
        if (urlSort) {
          const sortSelect = document.getElementById('SortBy');
          if (sortSelect) sortSelect.value = urlSort;
        }

        initInfiniteScroll();
      })
      .catch(err => console.error('Collection filter error:', err))
      .finally(() => gridOverlay?.classList.remove('is-visible'));
  };

  const applyFilters = (url) => {
    history.pushState({}, '', url);
    fetchAndUpdate(url);
  };

  // ── Init ──────────────────────────────────────────────

  const initCollection = () => {
    const section = document.querySelector('.collection-page');
    if (!section) return;

    // Filter sidebar toggle
    const toggleBtn      = document.querySelector('.collection-filter-toggle');
    const filtersPanel   = document.getElementById('CollectionFilters');
    const filtersOverlay = document.getElementById('CollectionFiltersOverlay');
    const closeBtn       = document.querySelector('.collection-filters__close');

    const isMobile = () => window.innerWidth < 1024;

    const openFilters = () => {
      if (!filtersPanel) return;
      filtersPanel.classList.add('is-open');
      toggleBtn?.setAttribute('aria-expanded', 'true');
      if (isMobile()) {
        filtersOverlay?.classList.add('is-visible');
        filtersOverlay?.removeAttribute('aria-hidden');
        document.body.style.overflow = 'hidden';
      }
    };

    const closeFilters = () => {
      if (!filtersPanel) return;
      filtersPanel.classList.remove('is-open');
      toggleBtn?.setAttribute('aria-expanded', 'false');
      filtersOverlay?.classList.remove('is-visible');
      filtersOverlay?.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };

    if (toggleBtn && filtersPanel) {
      if (!isMobile()) openFilters();

      toggleBtn.addEventListener('click', () =>
        filtersPanel.classList.contains('is-open') ? closeFilters() : openFilters()
      );
      closeBtn?.addEventListener('click', closeFilters);
      filtersOverlay?.addEventListener('click', closeFilters);
      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024) {
          filtersOverlay?.classList.remove('is-visible');
          filtersOverlay?.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      }, { passive: true });
    }

    initPriceSliders(section);
    initFilterAccordion(section);
    initFacultySearch(section);

    // Auto-apply on any filter change (checkbox, sort select, price slider release)
    const form = document.getElementById('CollectionFiltersForm');
    const submitForm = () => {
      const params = new URLSearchParams();
      for (const [key, value] of new FormData(form).entries()) {
        if (value !== '') params.append(key, value);
      }
      applyFilters(window.location.pathname + '?' + params.toString());
    };
    form?.addEventListener('change', submitForm);
    form?.addEventListener('submit', (e) => { e.preventDefault(); submitForm(); });

    // Active filter chips + "Clear all" → AJAX (delegated, survives DOM replacement)
    document.getElementById('CollectionFilters')?.addEventListener('click', (e) => {
      const chip = e.target.closest('.collection-active-filter');
      if (!chip) return;
      e.preventDefault();
      applyFilters(chip.href);
    });

    // Browser back/forward
    window.addEventListener('popstate', () => fetchAndUpdate(window.location.href));

    initInfiniteScroll();
    syncLecFilters(window.location.href);
    initTopBarFilters();
  };

  const initTopBarFilters = () => {
    const sortSel = document.getElementById('TopBarSortBy');
    if (sortSel) {
      sortSel.addEventListener('change', () => {
        const url = new URL(window.location.href);
        if (sortSel.value) {
          url.searchParams.set('sort_by', sortSel.value);
        } else {
          url.searchParams.delete('sort_by');
        }
        url.searchParams.delete('page');
        applyFilters(url.toString());
      });
    }

    document.querySelectorAll('.coll-topbar-tag-select').forEach(sel => {
      sel.addEventListener('change', () => {
        const url = new URL(window.location.href);
        const prefix = sel.dataset.tagPrefix + ':';
        const existing = url.searchParams.getAll('filter.p.tag').filter(t => !t.startsWith(prefix));
        url.searchParams.delete('filter.p.tag');
        existing.forEach(t => url.searchParams.append('filter.p.tag', t));
        if (sel.value) url.searchParams.append('filter.p.tag', sel.value);
        url.searchParams.delete('page');
        applyFilters(url.toString());
      });
    });
  };

  document.addEventListener('DOMContentLoaded', initCollection);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.collection-page')) initCollection();
  });

  // Sync GlobalCompare UI when AJAX grid updates (infinite scroll)
  (() => {
    var grid = document.getElementById('CollectionMain');
    if (!grid) return;
    new MutationObserver(function() {
      if (window.GlobalCompare) window.GlobalCompare.syncPageUI();
    }).observe(grid, { childList: true, subtree: true });
  })();

  /* ── Faculty / Attempt metafield client-side filters ────────────── */
  (() => {
    function applyMetaFilters() {
      var active = {};
      document.querySelectorAll('.lec-meta-cb:checked').forEach(function(cb) {
        var key = cb.dataset.metaKey;
        if (!active[key]) active[key] = [];
        active[key].push(cb.value.trim().toLowerCase());
      });

      var hasFilters = Object.keys(active).length > 0;
      document.querySelectorAll('#CollectionGrid .collection-grid__item').forEach(function(item) {
        if (!hasFilters) { item.style.display = ''; return; }
        var show = Object.keys(active).every(function(key) {
          var itemVal = (item.dataset[key] || '').trim().toLowerCase();
          return active[key].includes(itemVal);
        });
        item.style.display = show ? '' : 'none';
      });
    }

    document.addEventListener('change', function(e) {
      if (e.target.classList.contains('lec-meta-cb')) applyMetaFilters();
    });

    /* Re-apply after AJAX grid update */
    var grid = document.getElementById('CollectionGrid');
    if (grid) {
      new MutationObserver(applyMetaFilters).observe(grid, { childList: true });
    }
  })();

  /* ── Subject filter strip ─────────────────────────────────────────── */
  (() => {
    /* Delegate from content column so it survives strip replacement after AJAX */
    var content = document.querySelector('.collection-page__content');
    if (!content) return;

    content.addEventListener('click', (e) => {
      var chip = e.target.closest('.coll-subject-chip');
      if (!chip) return;
      var strip = chip.closest('.coll-subject-strip');
      if (!strip) return;

      var url = chip.dataset.subjectUrl;
      if (!url) {
        /* "All" chip — remove the subject filter param from the current URL */
        var parsed = new URL(window.location.href);
        parsed.searchParams.delete(strip.dataset.filterParam);
        parsed.searchParams.delete('page');
        url = parsed.toString();
      }
      applyFilters(url);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-list-collections"]) return;
  try {
    
  const initCollectionsList = () => {
    const section = document.querySelector('.collections-page');
    if (!section) return;

    const grid = document.getElementById('CollectionsGrid');
    const sentinel = document.getElementById('CollectionsSentinel');
    const loading = document.getElementById('CollectionsLoading');
    const endMsg = document.getElementById('CollectionsEnd');

    if (!grid || !sentinel) return;

    let isFetching = false;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting || isFetching) return;

      const nextUrl = grid.dataset.nextUrl;
      if (!nextUrl) {
        observer.disconnect();
        sentinel.remove();
        endMsg?.removeAttribute('aria-hidden');
        return;
      }

      isFetching = true;
      loading?.removeAttribute('aria-hidden');

      fetch(nextUrl)
        .then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('.collection-card');
          const newNextUrl = doc.getElementById('CollectionsGrid')?.dataset.nextUrl || '';

          newItems.forEach((item) => grid.appendChild(item));
          grid.dataset.nextUrl = newNextUrl;

          loading?.setAttribute('aria-hidden', 'true');
          isFetching = false;

          if (!newNextUrl) {
            observer.disconnect();
            sentinel.remove();
            endMsg?.removeAttribute('aria-hidden');
          }
        })
        .catch(() => {
          loading?.setAttribute('aria-hidden', 'true');
          isFetching = false;
        });
    }, { rootMargin: '300px' });

    observer.observe(sentinel);
  };

  document.addEventListener('DOMContentLoaded', initCollectionsList);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.collections-page')) initCollectionsList();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter"] && !Shopify.designMode) return;
  try {
    
  (function () {
    const form = document.querySelector('#newsletter-form');
    if (!form) return;

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const input  = form.querySelector('input[type="email"]');
      if (!input.value) return;

      button.disabled = true;
      button.classList.add('is-loading');

      try {
        const formData = new FormData(form);
        const response = await fetch(form.action || '/contact', {
          method: 'POST',
          body: formData,
          headers: { Accept: 'text/html' }
        });

        if (response.ok) {
          if (window.showToast) window.showToast('Thank you for subscribing!', 'check');
          form.reset();
        } else {
          throw new Error();
        }
      } catch {
        if (window.showToast) window.showToast('Something went wrong. Please try again.', 'alert-circle');
      } finally {
        button.disabled = false;
        button.classList.remove('is-loading');
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["offers-carousel"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('.offers-carousel').forEach(section => {
      const track      = section.querySelector('.offers-carousel__track');
      const cards      = Array.from(section.querySelectorAll('.offers-carousel__card'));
      const prevBtn    = section.querySelector('.offers-carousel__nav--prev');
      const nextBtn    = section.querySelector('.offers-carousel__nav--next');
      const dots       = Array.from(section.querySelectorAll('.offers-carousel__dot'));
      const counterCur = section.querySelector('.offers-carousel__counter-current');

      if (!track || cards.length === 0) return;

      const total   = parseInt(track.dataset.total, 10);
      let perView   = parseInt(track.dataset.perView, 10) || 3;
      let current   = 0; // index of leftmost visible card

      // On mobile force single view
      const mobileBreak = 767;
      const isMobile = () => window.innerWidth <= mobileBreak;

      const getPerView = () => isMobile() ? 1 : perView;

      const centerIndex = () => current + Math.floor(getPerView() / 2);

      const getCardWidth = () => {
        if (cards[0]) return cards[0].offsetWidth + 20; // 20 = gap in px (1.25rem)
        return 0;
      };

      const update = () => {
        const pv = getPerView();
        const offset = current * getCardWidth();
        track.style.transform = `translateX(-${offset}px)`;

        const ci = centerIndex();

        // Active card
        cards.forEach((card, i) => {
          card.classList.toggle('is-active', i === ci);
        });

        // Counter
        if (counterCur) counterCur.textContent = Math.min(ci + 1, total);

        // Dots
        dots.forEach((dot, i) => dot.classList.toggle('is-active', i === ci));

        // Nav states
        prevBtn.disabled = current <= 0;
        nextBtn.disabled = current >= total - pv;
      };

      prevBtn.addEventListener('click', () => {
        if (current > 0) { current--; update(); }
      });

      nextBtn.addEventListener('click', () => {
        if (current < total - getPerView()) { current++; update(); }
      });

      dots.forEach((dot, i) => {
        dot.addEventListener('click', () => {
          const pv = getPerView();
          current = Math.min(i, total - pv);
          if (current < 0) current = 0;
          update();
        });
      });

      // Recalculate on resize
      let resizeTimer;
      window.addEventListener('resize', () => {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          current = Math.min(current, Math.max(0, total - getPerView()));
          update();
        }, 150);
      }, { passive: true });

      // Re-init on Shopify section reload
      document.addEventListener('shopify:section:load', e => {
        if (e.target.contains(section)) { current = 0; update(); }
      });

      update();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.ptabs-wrap').forEach(function(wrap) {
    wrap.querySelectorAll('.ptabs-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.dataset.ptab;
        wrap.querySelectorAll('.ptabs-btn').forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        wrap.querySelectorAll('.ptabs-panel').forEach(function(p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = wrap.querySelector('[data-ppanel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    const gallery = document.getElementById('product-gallery');
    if (!gallery) return;

    const track = document.getElementById('gallery-track');
    const slides = track ? track.querySelectorAll('.product-gallery__slide') : [];
    const thumbs = document.querySelectorAll('.product-gallery__thumb');
    const prevBtn = document.getElementById('gallery-prev');
    const nextBtn = document.getElementById('gallery-next');
    const currentEl = document.getElementById('gallery-current');
    const totalEl = document.getElementById('gallery-total');
    const total = slides.length;

    // Map image ID (string) → slide index for fast variant image switching
    const imageIndexMap = {};
    slides.forEach((slide, i) => {
      if (slide.dataset.imageId) imageIndexMap[slide.dataset.imageId] = i;
    });

    let current = 0;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      if (thumbs[current]) thumbs[current].classList.remove('is-active');
      current = (index + total) % total;
      slides[current].classList.add('is-active');
      if (thumbs[current]) {
        thumbs[current].classList.add('is-active');
        if (thumbsTrack && thumbsWrap) {
          const activeThumb = thumbs[current];
          const thumbLeft = activeThumb.offsetLeft;
          const thumbRight = thumbLeft + activeThumb.offsetWidth;
          const wrapWidth = thumbsWrap.offsetWidth;
          if (thumbLeft < thumbOffset) {
            thumbOffset = thumbLeft;
            thumbsTrack.style.transform = 'translateX(-' + thumbOffset + 'px)';
          } else if (thumbRight > thumbOffset + wrapWidth) {
            thumbOffset = thumbRight - wrapWidth;
            thumbsTrack.style.transform = 'translateX(-' + thumbOffset + 'px)';
          }
          updateThumbArrows();
        }
      }
      if (currentEl) currentEl.textContent = current + 1;
      if (prevBtn) prevBtn.classList.toggle('is-hidden', total <= 1);
      if (nextBtn) nextBtn.classList.toggle('is-hidden', total <= 1);
    }

    if (prevBtn) prevBtn.addEventListener('click', () => goTo(current - 1));
    if (nextBtn) nextBtn.addEventListener('click', () => goTo(current + 1));

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => goTo(i));
    });

    if (total <= 1) {
      if (prevBtn) prevBtn.classList.add('is-hidden');
      if (nextBtn) nextBtn.classList.add('is-hidden');
    }

    const thumbPrevBtn = document.getElementById('thumb-prev');
    const thumbNextBtn = document.getElementById('thumb-next');
    const thumbsTrack = document.getElementById('gallery-thumbs');
    const thumbsWrap = thumbsTrack ? thumbsTrack.closest('.product-gallery__thumbs-track-wrap') : null;

    function getThumbScrollAmount() {
      const thumb = thumbsTrack ? thumbsTrack.querySelector('.product-gallery__thumb') : null;
      if (!thumb || !thumbsWrap) return 0;
      const thumbWidth = thumb.offsetWidth + 8;
      const visible = Math.floor(thumbsWrap.offsetWidth / thumbWidth);
      return thumbWidth * Math.max(1, visible - 1);
    }

    let thumbOffset = 0;

    function updateThumbArrows() {
      if (!thumbsTrack || !thumbsWrap) return;
      const maxOffset = thumbsTrack.scrollWidth - thumbsWrap.offsetWidth;
      if (thumbPrevBtn) thumbPrevBtn.disabled = thumbOffset <= 0;
      if (thumbNextBtn) thumbNextBtn.disabled = thumbOffset >= maxOffset;
    }

    function scrollThumbs(dir) {
      if (!thumbsTrack || !thumbsWrap) return;
      const amount = getThumbScrollAmount();
      const maxOffset = thumbsTrack.scrollWidth - thumbsWrap.offsetWidth;
      thumbOffset = Math.max(0, Math.min(maxOffset, thumbOffset + dir * amount));
      thumbsTrack.style.transform = 'translateX(-' + thumbOffset + 'px)';
      updateThumbArrows();
    }

    if (thumbPrevBtn) thumbPrevBtn.addEventListener('click', () => scrollThumbs(-1));
    if (thumbNextBtn) thumbNextBtn.addEventListener('click', () => scrollThumbs(1));

    updateThumbArrows();

    const zoomOverlay = document.getElementById('zoom-overlay');
    const zoomImg = document.getElementById('zoom-img');
    const zoomImgWrap = document.getElementById('zoom-img-wrap');
    const zoomClose = document.getElementById('zoom-close');

    document.querySelectorAll('.product-gallery__zoom-trigger').forEach(btn => {
      btn.addEventListener('click', () => {
        const src = btn.dataset.zoomSrc;
        zoomImg.src = src;
        zoomImgWrap.classList.remove('is-zoomed');
        zoomOverlay.classList.add('is-open');
        zoomOverlay.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
      });
    });

    zoomImgWrap.addEventListener('click', () => {
      zoomImgWrap.classList.toggle('is-zoomed');
    });

    function closeZoom() {
      zoomOverlay.classList.remove('is-open');
      zoomOverlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(() => { zoomImg.src = ''; }, 300);
    }

    if (zoomClose) zoomClose.addEventListener('click', closeZoom);
    zoomOverlay.addEventListener('click', (e) => {
      if (e.target === zoomOverlay) closeZoom();
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && zoomOverlay.classList.contains('is-open')) closeZoom();
      if (e.key === 'ArrowLeft' && !zoomOverlay.classList.contains('is-open')) goTo(current - 1);
      if (e.key === 'ArrowRight' && !zoomOverlay.classList.contains('is-open')) goTo(current + 1);
    });

    const quantityInput = document.getElementById('quantity-input');
    const decreaseBtn = document.getElementById('qty-decrease');
    const increaseBtn = document.getElementById('qty-increase');

    if (decreaseBtn && increaseBtn && quantityInput) {
      decreaseBtn.addEventListener('click', () => {
        const val = parseInt(quantityInput.value, 10);
        if (val > 1) quantityInput.value = val - 1;
      });
      increaseBtn.addEventListener('click', () => {
        quantityInput.value = parseInt(quantityInput.value, 10) + 1;
      });
    }

    const productForm = document.getElementById('product-form');
    const addToCartBtn = document.getElementById('add-to-cart-btn');
    const variantInput = document.getElementById('variant-id-input');

    const optionInputs = productForm ? productForm.querySelectorAll('.product-form__option-input') : [];
    const optionSelects = productForm ? productForm.querySelectorAll('.product-form__option-select') : [];
    const variantsDataEl = document.getElementById('product-variants-data');
    const productVariants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];

    const designSelect = productForm ? productForm.querySelector('.product-form__design-select') : null;
    const noDesignRadio = designSelect
      ? productForm.querySelector('.product-form__option-input[value="No Design"]')
      : null;

    function findVariant() {
      const selected = {};
      optionInputs.forEach(input => {
        if (input.checked) {
          selected[parseInt(input.dataset.optionPosition, 10)] = input.value;
        }
      });
      optionSelects.forEach(select => {
        if (select.value !== '') {
          selected[parseInt(select.dataset.optionPosition, 10)] = select.value;
        }
      });
      return productVariants.find(v => {
        return Object.entries(selected).every(([pos, val]) => {
          return v['option' + pos] === val;
        });
      });
    }

    function _applyButtonState(available, customisationOk, unavailableLabel) {
      const canAdd = available && customisationOk;
      addToCartBtn.disabled = !canAdd;
      if (buyNowBtn) buyNowBtn.disabled = !canAdd;
      if (stickyAddBtn) stickyAddBtn.disabled = !canAdd;
      if (stickyBuyBtn) stickyBuyBtn.disabled = !canAdd;
      const addText = addToCartBtn.querySelector('.add-to-cart-text');
      if (addText) {
        if (!available) addText.textContent = unavailableLabel || 'Sold out';
        else if (!customisationOk) addText.textContent = 'Complete customisation';
        else addText.textContent = 'Add to cart';
      }
    }

    function formatMoney(cents) {
      const currency = window.Shopify?.currency?.active || 'USD';
      return (cents / 100).toLocaleString('en', { style: 'currency', currency });
    }

    const mainPriceEl = document.querySelector('.product-info__price');

    function updateMainPrice(variant) {
      if (!mainPriceEl) return;
      if (variant.compare_at_price > variant.price) {
        const savings = Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price);
        mainPriceEl.innerHTML =
          '<span class="product-info__price-sale">' + formatMoney(variant.price) + '</span>' +
          '<span class="product-info__price-compare">' + formatMoney(variant.compare_at_price) + '</span>' +
          '<span class="product-info__price-badge">Save ' + savings + '%</span>';
      } else {
        mainPriceEl.innerHTML = '<span class="product-info__price-regular">' + formatMoney(variant.price) + '</span>';
      }
    }

    function updateOptionAvailability() {
      // Build current selection map, excluding each position when evaluating it
      const selected = {};
      optionInputs.forEach(input => {
        if (input.checked) selected[parseInt(input.dataset.optionPosition, 10)] = input.value;
      });
      optionSelects.forEach(select => {
        if (select.value !== '') selected[parseInt(select.dataset.optionPosition, 10)] = select.value;
      });

      // Update radio button availability
      optionInputs.forEach(input => {
        const pos = parseInt(input.dataset.optionPosition, 10);
        const value = input.value;
        const isAvailable = productVariants.some(v => {
          if (!v.available) return false;
          if (v['option' + pos] !== value) return false;
          return Object.entries(selected).every(([p, val]) => parseInt(p) === pos || v['option' + p] === val);
        });
        const label = productForm.querySelector('label[for="' + input.id + '"]');
        if (isAvailable) {
          input.removeAttribute('data-unavailable');
          if (label) label.classList.remove('is-unavailable');
        } else {
          input.setAttribute('data-unavailable', '');
          if (label) label.classList.add('is-unavailable');
        }
      });

      // Update select option availability
      optionSelects.forEach(select => {
        const pos = parseInt(select.dataset.optionPosition, 10);
        Array.from(select.options).forEach(opt => {
          if (!opt.value) return;
          const value = opt.value;
          const isAvailable = productVariants.some(v => {
            if (!v.available) return false;
            if (v['option' + pos] !== value) return false;
            return Object.entries(selected).every(([p, val]) => parseInt(p) === pos || v['option' + p] === val);
          });
          opt.disabled = !isAvailable;
          // Keep "(unavailable)" suffix in sync
          const baseText = opt.textContent.replace(' (unavailable)', '');
          opt.textContent = isAvailable ? baseText : baseText + ' (unavailable)';
        });
      });
    }

    function updateVariant() {
      const variant = findVariant();
      updateOptionAvailability();
      if (!variant) {
        _applyButtonState(false, true, 'Unavailable');
        return;
      }
      variantInput.value = variant.id;

      updateMainPrice(variant);

      // Navigate gallery to the variant's featured image
      if (variant.featured_image) {
        const idx = imageIndexMap[String(variant.featured_image.id)];
        if (idx !== undefined) goTo(idx);
      }

      document.dispatchEvent(new CustomEvent('variant:changed', { detail: { variant } }));
      _applyButtonState(variant.available, window.ProductCustomisation ? window.ProductCustomisation.isValid() : true);
    }

    document.addEventListener('customisation:validated', (e) => {
      const variant = findVariant();
      _applyButtonState(variant ? variant.available : false, e.detail.valid, variant ? undefined : 'Unavailable');
    });

    updateOptionAvailability();

    optionInputs.forEach(input => {
      input.addEventListener('change', () => {
        // When "No Design" radio is selected, clear the design dropdown
        if (input === noDesignRadio && input.checked && designSelect) {
          designSelect.value = '';
        }
        updateVariant();
      });
    });
    optionSelects.forEach(select => {
      select.addEventListener('change', () => {
        // When a design is chosen from dropdown, uncheck "No Design" radio
        if (select === designSelect && select.value !== '' && noDesignRadio) {
          noDesignRadio.checked = false;
        }
        updateVariant();
      });
    });

    if (productForm) {
      productForm.addEventListener('submit', async (e) => {
        e.preventDefault();
        e.stopPropagation();
        const qty = parseInt(quantityInput ? quantityInput.value : 1, 10);
        const variantId = variantInput.value;
        addToCartBtn.classList.add('is-loading');
        addToCartBtn.disabled = true;

        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: window.ProductCustomisation?.getProperties() || {} }] })
          });
          const data = await res.json();
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } else {
            if (window.showToast) window.showToast(data.description || 'Could not add to cart', 'alert-circle');
          }
        } catch(err) {
          if (window.showToast) window.showToast('An error occurred', 'alert-triangle');
        } finally {
          addToCartBtn.classList.remove('is-loading');
          addToCartBtn.disabled = false;
        }
      });
    }

    const buyNowBtn = document.getElementById('buy-now-btn');
    if (buyNowBtn) {
      buyNowBtn.addEventListener('click', async () => {
        const qty = parseInt(quantityInput ? quantityInput.value : 1, 10);
        const variantId = variantInput.value;
        const originalText = buyNowBtn.textContent;
        buyNowBtn.disabled = true;
        buyNowBtn.textContent = 'Loading...';
        try {
          const res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: qty, properties: window.ProductCustomisation?.getProperties() || {} }] })
          });
          const data = await res.json();
          if (res.ok) {
            window.location.href = '/checkout';
          } else {
            if (window.showToast) window.showToast(data.description || 'Could not proceed', 'alert-circle');
          }
        } catch(err) {
          if (window.showToast) window.showToast('An error occurred', 'alert-triangle');
        } finally {
          buyNowBtn.disabled = false;
          buyNowBtn.textContent = originalText;
        }
      });
    }

    const stickyAtc = document.getElementById('sticky-atc');
    const stickyAddBtn = document.getElementById('sticky-atc-add');
    const stickyBuyBtn = document.getElementById('sticky-atc-buy');
    const stickyQtyInput = document.getElementById('sticky-qty-input');
    const stickyQtyDec = document.getElementById('sticky-qty-decrease');
    const stickyQtyInc = document.getElementById('sticky-qty-increase');
    const stickyPriceEl = document.getElementById('sticky-atc-price');

    if (stickyAtc && addToCartBtn) {
      const observer = new IntersectionObserver(function(entries) {
        const visible = entries[0].isIntersecting;
        stickyAtc.classList.toggle('is-visible', !visible);
        stickyAtc.setAttribute('aria-hidden', visible ? 'true' : 'false');
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

      observer.observe(addToCartBtn);

      function updateStickyPrice(variant) {
        if (!stickyPriceEl) return;
        if (variant.compare_at_price > variant.price) {
          stickyPriceEl.innerHTML =
            '<span class="sticky-atc__price-sale">' + formatMoney(variant.price) + '</span>' +
            '<span class="sticky-atc__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
        } else {
          stickyPriceEl.innerHTML = '<span class="sticky-atc__price-regular">' + formatMoney(variant.price) + '</span>';
        }
      }

      document.addEventListener('variant:changed', function(e) {
        updateStickyPrice(e.detail.variant);
      });

      if (stickyQtyDec && stickyQtyInc && stickyQtyInput) {
        stickyQtyDec.addEventListener('click', function() {
          var v = parseInt(stickyQtyInput.value, 10);
          if (v > 1) stickyQtyInput.value = v - 1;
        });
        stickyQtyInc.addEventListener('click', function() {
          stickyQtyInput.value = parseInt(stickyQtyInput.value, 10) + 1;
        });
      }

      async function stickyAddToCart() {
        if (!variantInput) return;
        var qty = parseInt(stickyQtyInput ? stickyQtyInput.value : 1, 10);
        stickyAddBtn.classList.add('is-loading');
        stickyAddBtn.disabled = true;
        try {
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantInput.value, quantity: qty, properties: window.ProductCustomisation?.getProperties() || {} }] })
          });
          var data = await res.json();
          if (res.ok) {
            document.dispatchEvent(new CustomEvent('cart:updated'));
          } else {
            if (window.showToast) window.showToast(data.description || 'Could not add to cart', 'alert-circle');
          }
        } catch(e) {
          if (window.showToast) window.showToast('An error occurred', 'alert-triangle');
        } finally {
          stickyAddBtn.classList.remove('is-loading');
          stickyAddBtn.disabled = false;
        }
      }

      if (stickyAddBtn) stickyAddBtn.addEventListener('click', stickyAddToCart);

      if (stickyBuyBtn) {
        stickyBuyBtn.addEventListener('click', async function() {
          if (!variantInput) return;
          var qty = parseInt(stickyQtyInput ? stickyQtyInput.value : 1, 10);
          var orig = stickyBuyBtn.textContent;
          stickyBuyBtn.disabled = true;
          stickyBuyBtn.textContent = 'Loading...';
          try {
            var res = await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: variantInput.value, quantity: qty, properties: window.ProductCustomisation?.getProperties() || {} }] })
            });
            var data = await res.json();
            if (res.ok) { window.location.href = '/checkout'; }
            else {
              if (window.showToast) window.showToast(data.description || 'Could not proceed', 'alert-circle');
            }
          } catch(e) {
            if (window.showToast) window.showToast('An error occurred', 'alert-triangle');
          } finally {
            stickyBuyBtn.disabled = false;
            stickyBuyBtn.textContent = orig;
          }
        });
      }
    }

    // ── Shipping notice ────────────────────────────────────
    const shippingNotice = document.getElementById('shipping-notice');
    if (shippingNotice) {
      const isBolt        = shippingNotice.dataset.bolt === 'true';
      const isPersonalised = shippingNotice.dataset.personalised === 'true';

      function updateShippingNotice(variantTitle) {
        const isNoDesign = variantTitle.toLowerCase().includes('no design');
        let msg;
        if (isBolt || isNoDesign) {
          msg = 'This product ships immediately.';
        } else if (isPersonalised) {
          msg = 'This is a personalised product. It may take up to 14 business days to ship.';
        } else {
          msg = 'This product ships within 7–14 business days.';
        }
        shippingNotice.innerHTML = '<strong>Please Note:</strong>&nbsp;' + msg;
      }

      document.addEventListener('variant:changed', (e) => {
        updateShippingNotice(e.detail.variant.title || '');
      });
    }

    // ── Accordion animation ────────────────────────────────
    document.querySelectorAll('.product-accordion__summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const details = summary.closest('.product-accordion');
        const body = details.querySelector('.product-accordion__content');
        if (!body) return;

        if (details.open) {
          body.style.height = body.scrollHeight + 'px';
          void body.offsetHeight;
          body.style.height = '0px';
          body.addEventListener('transitionend', () => {
            details.removeAttribute('open');
          }, { once: true });
        } else {
          details.setAttribute('open', '');
          const h = body.scrollHeight;
          body.style.height = '0px';
          void body.offsetHeight;
          body.style.height = h + 'px';
          body.addEventListener('transitionend', () => {
            body.style.height = 'auto';
          }, { once: true });
        }
      });
    });

  })();

  // Detail Tabs
  document.querySelectorAll('.product-detail-tabs').forEach(function(tabs) {
    tabs.querySelectorAll('.pdt-tab-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var target = btn.dataset.tab;
        tabs.querySelectorAll('.pdt-tab-btn').forEach(function(b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-selected', 'false');
        });
        tabs.querySelectorAll('.pdt-tab-panel').forEach(function(p) {
          p.classList.remove('is-active');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = tabs.querySelector('[data-panel="' + target + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  });



  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reels"] && !Shopify.designMode) return;
  try {
    
  (() => {

    // ── IntersectionObserver: autoplay when visible ──────────
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        const video = entry.target.querySelector('.reel__video');
        if (!video) return;
        if (entry.isIntersecting) {
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });

    function initReels(section) {
      const reels = section.querySelectorAll('.reel');
      const track = section.querySelector('.reels-section__track');
      const dots  = section.querySelectorAll('.reels-section__dot');

      reels.forEach(reel => {
        const video = reel.querySelector('.reel__video');
        if (video) {
          video.muted = true;
          observer.observe(reel);
        }

        // Mute toggle — only 1 video unmuted at a time
        const muteBtn = reel.querySelector('.reel__mute-btn');
        if (muteBtn && video) {
          muteBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            const isCurrentlyMuted = video.muted;
            // Mute all reels first
            document.querySelectorAll('.reel__video').forEach(v => { v.muted = true; });
            document.querySelectorAll('.reel').forEach(r => { r.classList.remove('is-unmuted'); });
            // If this one was muted, unmute it; if it was already unmuted, it stays muted (toggle off)
            if (isCurrentlyMuted) {
              video.muted = false;
              reel.classList.add('is-unmuted');
            }
          });
        }

        // Discover button — link takes priority over popup
        const discoverBtn = reel.querySelector('.reel__discover-btn');
        if (discoverBtn) {
          discoverBtn.addEventListener('click', (e) => {
            e.stopPropagation();
            if (discoverBtn.dataset.link) {
              window.open(discoverBtn.dataset.link, '_blank', 'noopener,noreferrer');
            } else {
              openReelModal(discoverBtn.dataset.reelId);
            }
          });
        }
      });

      if (!track) return;

      // Nav arrows
      section.querySelectorAll('.reels-section__nav').forEach(btn => {
        btn.addEventListener('click', () => {
          const reelWidth = track.querySelector('.reel')?.offsetWidth || 300;
          const gap = 8;
          const scrollBy = btn.classList.contains('reels-section__nav--prev')
            ? -(reelWidth + gap)
            : (reelWidth + gap);
          track.scrollBy({ left: scrollBy, behavior: 'smooth' });
        });
      });

      // Dots: update active on scroll, click to jump
      if (dots.length) {
        let scrollTimer;
        track.addEventListener('scroll', () => {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(() => {
            const reelWidth = track.querySelector('.reel')?.offsetWidth || 1;
            const gap = parseFloat(getComputedStyle(track).gap) || 8;
            const idx = Math.round(track.scrollLeft / (reelWidth + gap));
            dots.forEach((d, i) => d.classList.toggle('is-active', i === idx));
          }, 80);
        }, { passive: true });

        dots.forEach((dot, idx) => {
          dot.addEventListener('click', () => {
            const reelWidth = track.querySelector('.reel')?.offsetWidth || 300;
            const gap = parseFloat(getComputedStyle(track).gap) || 8;
            track.scrollTo({ left: idx * (reelWidth + gap), behavior: 'smooth' });
          });
        });
      }
    }

    // ── Product modal ────────────────────────────────────────
    const modal = document.getElementById('ReelProductModal');
    const grid  = document.getElementById('ReelModalGrid');

    function openReelModal(reelId) {
      if (!modal || !grid) return;
      const source = document.getElementById('reel-products-' + reelId);
      if (!source) return;

      grid.innerHTML = source.innerHTML;
      modal.removeAttribute('hidden');
      requestAnimationFrame(() => modal.classList.add('is-open'));
      document.body.style.overflow = 'hidden';

      // Bind ATC buttons in modal
      grid.querySelectorAll('.reel-product-card__atc').forEach(btn => {
        btn.addEventListener('click', () => handleAtc(btn));
      });
    }

    function closeReelModal() {
      if (!modal) return;
      modal.classList.remove('is-open');
      modal.addEventListener('transitionend', () => {
        modal.setAttribute('hidden', '');
        document.body.style.overflow = '';
        if (grid) grid.innerHTML = '';
      }, { once: true });
    }

    if (modal) {
      modal.querySelector('.reel-modal__backdrop')?.addEventListener('click', closeReelModal);
      modal.querySelector('.reel-modal__close')?.addEventListener('click', closeReelModal);
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeReelModal();
      });
    }

    // ── Add to cart ──────────────────────────────────────────
    async function handleAtc(btn) {
      const variantId = btn.dataset.variantId;
      if (!variantId) return;

      btn.classList.add('is-loading');
      const originalText = btn.textContent;
      btn.textContent = 'Adding…';

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 }),
        });
        if (!res.ok) throw new Error();
        btn.textContent = 'Added!';
        document.dispatchEvent(new CustomEvent('cart:updated'));
        if (window.showToast) window.showToast('Item added to cart', 'shopping-cart');
        setTimeout(() => { btn.textContent = originalText; }, 2000);
      } catch {
        btn.textContent = 'Error';
        setTimeout(() => { btn.textContent = originalText; }, 2000);
      } finally {
        btn.classList.remove('is-loading');
      }
    }

    // ── Init ─────────────────────────────────────────────────
    function init() {
      document.querySelectorAll('.reels-section').forEach(initReels);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.reels-section');
      if (section) initReels(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initSection(section) {
      const productId = section.dataset.productId;
      const sectionId = section.dataset.sectionId;

      if (!productId) return;

      function setupCarousel() {
        const track = section.querySelector('.related-products__track');
        const cards = track ? track.querySelectorAll('.related-products__card') : [];
        const prevBtn = section.querySelector('.rp-nav-btn--prev');
        const nextBtn = section.querySelector('.rp-nav-btn--next');

        if (!track || !cards.length) return;

        let current = 0;

        function getCols() {
          return window.matchMedia('(max-width: 767px)').matches ? 2 : 4;
        }

        function getCardStep() {
          if (cards.length >= 2) {
            return cards[1].getBoundingClientRect().left - cards[0].getBoundingClientRect().left;
          }
          if (cards[0]) {
            const gap = parseFloat(getComputedStyle(track).gap) || 24;
            return cards[0].getBoundingClientRect().width + gap;
          }
          return 0;
        }

        function update() {
          const cols = getCols();
          const maxIndex = Math.max(0, cards.length - cols);
          current = Math.max(0, Math.min(current, maxIndex));
          track.style.transform = 'translateX(-' + (current * getCardStep()) + 'px)';
          if (prevBtn) prevBtn.disabled = current === 0;
          if (nextBtn) nextBtn.disabled = current >= maxIndex;
        }

        if (prevBtn) prevBtn.addEventListener('click', () => { current -= 1; update(); });
        if (nextBtn) nextBtn.addEventListener('click', () => { current += 1; update(); });

        window.addEventListener('resize', update);
        update();
      }

      if (section.querySelector('.related-products__track')) {
        setupCarousel();
        return;
      }

      fetch('/recommendations/products?section_id=' + sectionId + '&product_id=' + productId + '&limit=8&intent=related')
        .then(function(res) { return res.text(); })
        .then(function(html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var fetched = doc.getElementById('related-products-' + sectionId);
          if (!fetched || !fetched.querySelector('.related-products__track')) return;
          section.innerHTML = fetched.innerHTML;
          requestAnimationFrame(function() {
            requestAnimationFrame(function() {
              setupCarousel();
            });
          });
        })
        .catch(function() {});
    }

    document.querySelectorAll('.related-products-section').forEach(initSection);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-bar"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-search-outer]').forEach(outer => {
    const form      = outer.querySelector('[data-search-form]');
    const input     = outer.querySelector('[data-search-input]');
    const select    = outer.querySelector('[data-search-select]');
    const results   = outer.querySelector('[data-search-results]');
    const catDrop   = outer.querySelector('[data-cat-dropdown]');
    const catTrigger= outer.querySelector('[data-cat-trigger]');
    const catPanel  = outer.querySelector('[data-cat-panel]');
    const catLabel  = outer.querySelector('[data-cat-label]');
    const catOptions= [...outer.querySelectorAll('[data-cat-option]')];

    let debounceTimer = null;
    let activeIndex   = -1;

    // ── Category dropdown ───────────────────────────────────────────────
    function openLecturesPopup() {
      if (window.OPPopup) {
        window.OPPopup.open();
      } else {
        document.addEventListener('op:ready', function() { window.OPPopup.open(); }, { once: true });
      }
    }

    catTrigger.addEventListener('click', e => {
      e.stopPropagation();
      // If current category is Lectures, open the course popup instead
      if (catLabel.textContent.trim() === 'Lectures') {
        openLecturesPopup();
        return;
      }
      const isOpen = !catPanel.hidden;
      if (isOpen) { closeCat(); } else { openCat(); }
    });

    catOptions.forEach(opt => {
      opt.addEventListener('click', () => {
        const label = opt.textContent.trim();
        // If user picks Lectures from the panel, open popup instead of navigating
        if (label === 'Lectures') {
          closeCat();
          openLecturesPopup();
          return;
        }
        select.value = opt.dataset.value;
        catLabel.textContent = label;
        catOptions.forEach(o => { o.classList.remove('is-selected'); o.setAttribute('aria-selected','false'); });
        opt.classList.add('is-selected');
        opt.setAttribute('aria-selected', 'true');
        closeCat();
        input.focus();
      });
    });

    function openCat() {
      catPanel.hidden = false;
      catTrigger.setAttribute('aria-expanded', 'true');
      catDrop.setAttribute('data-open', '');
    }

    function closeCat() {
      catPanel.hidden = true;
      catTrigger.setAttribute('aria-expanded', 'false');
      catDrop.removeAttribute('data-open');
    }

    // ── Submit ──────────────────────────────────────────────────────────
    form.addEventListener('submit', e => {
      e.preventDefault();
      const q = input.value.trim();
      window.location.href = q
        ? '/search?q=' + encodeURIComponent(q) + '&type=product'
        : '/search';
    });

    // ── Input → fetch ───────────────────────────────────────────────────
    input.addEventListener('input', () => {
      clearTimeout(debounceTimer);
      const q = input.value.trim();
      if (q.length < 2) { closeResults(); return; }
      debounceTimer = setTimeout(() => fetchResults(q), 280);
    });

    // ── Keyboard nav ────────────────────────────────────────────────────
    input.addEventListener('keydown', e => {
      const items = [...results.querySelectorAll('[data-result-item]')];
      if (!items.length) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        activeIndex = Math.min(activeIndex + 1, items.length - 1);
        setActive(items);
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        activeIndex = Math.max(activeIndex - 1, -1);
        if (activeIndex === -1) { clearActive(items); input.focus(); }
        else setActive(items);
      } else if (e.key === 'Escape') {
        closeResults();
        input.focus();
      } else if (e.key === 'Enter' && activeIndex >= 0) {
        e.preventDefault();
        items[activeIndex].click();
      }
    });

    // ── Click outside → close both ──────────────────────────────────────
    document.addEventListener('click', e => {
      if (!outer.contains(e.target)) { closeResults(); closeCat(); }
    });

    // ── Fetch from Shopify Predictive Search API ─────────────────────────
    function fetchResults(q) {
      results.innerHTML = '<div class="search-bar__results-loading">Searching…</div>';
      openResults();

      fetch('/search/suggest.json?q=' + encodeURIComponent(q)
        + '&resources[type]=product&resources[limit]=6&section_id=search-bar')
        .then(r => r.json())
        .then(data => {
          console.log('[search suggest]', data);
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          renderResults(products, q);
        })
        .catch(() => {
          results.innerHTML = '<div class="search-bar__results-empty">Something went wrong. Try again.</div>';
        });
    }

    // ── Render ───────────────────────────────────────────────────────────
    function renderResults(products, q) {
      activeIndex = -1;
      if (!products.length) {
        results.innerHTML = '<div class="search-bar__results-empty">No results for "<strong>' + escHtml(q) + '</strong>"</div>';
        openResults();
        return;
      }

      const html = products.map(p => {
        const img   = p.featured_image ? p.featured_image.url : '';
        const price = p.price ? formatMoney(p.price) : '';
        return '<a href="' + escAttr(p.url) + '" class="search-bar__result-item" data-result-item role="option" tabindex="-1">'
          + (img ? '<img class="search-bar__result-img" src="' + escAttr(img) + '" alt="" loading="lazy" width="48" height="48">' : '<div class="search-bar__result-img search-bar__result-img--placeholder"></div>')
          + '<div class="search-bar__result-info">'
          +   '<span class="search-bar__result-title">' + escHtml(p.title) + '</span>'
          +   (price ? '<span class="search-bar__result-price">' + price + '</span>' : '')
          + '</div>'
          + '</a>';
      }).join('');

      results.innerHTML = html
        + '<a href="/search?q=' + encodeURIComponent(q) + '" class="search-bar__results-viewall">See all results for "<strong>' + escHtml(q) + '</strong>" →</a>';
      openResults();
    }

    function openResults() {
      results.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function closeResults() {
      results.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      activeIndex = -1;
    }

    function setActive(items) {
      clearActive(items);
      items[activeIndex].classList.add('is-active');
      items[activeIndex].focus();
    }

    function clearActive(items) {
      items.forEach(i => i.classList.remove('is-active'));
    }

    function formatMoney(amount) {
      return '₹' + Number(amount).toLocaleString('en-IN');
    }

    function escHtml(s) {
      return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    function escAttr(s) {
      return String(s).replace(/"/g, '&quot;');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  const initSearch = () => {
    const section = document.querySelector('.search-page');
    if (!section) return;

    // ── Filter sidebar toggle ──────────────────────────────
    const toggleBtn = section.querySelector('.collection-filter-toggle');
    const filtersPanel = document.getElementById('SearchFilters');
    const overlay = document.getElementById('SearchFiltersOverlay');
    const closeBtn = section.querySelector('.collection-filters__close');

    if (toggleBtn && filtersPanel) {
      const isMobile = () => window.innerWidth < 1024;

      const openFilters = () => {
        filtersPanel.classList.add('is-open');
        toggleBtn.setAttribute('aria-expanded', 'true');
        toggleBtn.querySelector('.collection-filter-toggle__text').textContent =
          toggleBtn.dataset.labelClose || 'Hide filters';
        if (isMobile()) {
          overlay?.classList.add('is-visible');
          overlay?.removeAttribute('aria-hidden');
          document.body.style.overflow = 'hidden';
        }
      };

      const closeFilters = () => {
        filtersPanel.classList.remove('is-open');
        toggleBtn.setAttribute('aria-expanded', 'false');
        toggleBtn.querySelector('.collection-filter-toggle__text').textContent =
          toggleBtn.dataset.labelOpen || 'Filters';
        overlay?.classList.remove('is-visible');
        overlay?.setAttribute('aria-hidden', 'true');
        document.body.style.overflow = '';
      };

      if (!isMobile()) openFilters();

      toggleBtn.addEventListener('click', () => {
        filtersPanel.classList.contains('is-open') ? closeFilters() : openFilters();
      });

      closeBtn?.addEventListener('click', closeFilters);
      overlay?.addEventListener('click', closeFilters);

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024) {
          overlay?.classList.remove('is-visible');
          overlay?.setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        }
      }, { passive: true });
    }

    // ── Price range sliders ────────────────────────────────
    section.querySelectorAll('.price-slider').forEach((slider) => {
      const minInput = slider.querySelector('.price-slider__input--min');
      const maxInput = slider.querySelector('.price-slider__input--max');
      const fill = slider.querySelector('.price-slider__fill');
      const minDisplay = slider.querySelector('.price-slider__min-display');
      const maxDisplay = slider.querySelector('.price-slider__max-display');
      const hiddenMin = slider.querySelector('.price-slider__hidden-min');
      const hiddenMax = slider.querySelector('.price-slider__hidden-max');
      if (!minInput || !maxInput || !fill) return;

      const rangeMin = parseFloat(slider.dataset.min);
      const rangeMax = parseFloat(slider.dataset.max);

      function updateFill(activeInput) {
        let lo = parseFloat(minInput.value);
        let hi = parseFloat(maxInput.value);

        if (lo > hi) {
          if (activeInput === minInput) { lo = hi; minInput.value = lo; }
          else { hi = lo; maxInput.value = hi; }
        }

        const loPct = ((lo - rangeMin) / (rangeMax - rangeMin)) * 100;
        const hiPct = ((hi - rangeMin) / (rangeMax - rangeMin)) * 100;

        fill.style.left = loPct + '%';
        fill.style.width = (hiPct - loPct) + '%';

        if (minDisplay) minDisplay.textContent = Math.round(lo);
        if (maxDisplay) maxDisplay.textContent = Math.round(hi);
        if (hiddenMin) hiddenMin.value = Math.round(lo);
        if (hiddenMax) hiddenMax.value = Math.round(hi);
      }

      minInput.addEventListener('input', () => {
        minInput.style.zIndex = 4;
        maxInput.style.zIndex = 3;
        updateFill(minInput);
      });
      maxInput.addEventListener('input', () => {
        maxInput.style.zIndex = 4;
        minInput.style.zIndex = 3;
        updateFill(maxInput);
      });

      updateFill(null);
    });

    // ── Filter group collapse ──────────────────────────────
    section.querySelectorAll('.collection-filter__summary').forEach((summary) => {
      summary.addEventListener('click', (e) => {
        e.preventDefault();
        const details = summary.closest('.collection-filter');
        const body = details.querySelector('.collection-filter__body');
        if (!body) return;

        if (details.open) {
          body.style.height = body.scrollHeight + 'px';
          void body.offsetHeight;
          body.style.height = '0px';
          body.addEventListener('transitionend', () => {
            details.removeAttribute('open');
          }, { once: true });
        } else {
          details.setAttribute('open', '');
          const h = body.scrollHeight;
          body.style.height = '0px';
          void body.offsetHeight;
          body.style.height = h + 'px';
          body.addEventListener('transitionend', () => {
            body.style.height = 'auto';
          }, { once: true });
        }
      });
    });

    // ── Faculty filter search ──────────────────────────────
    section.querySelectorAll('.collection-filter__search-input').forEach((input) => {
      input.addEventListener('input', (e) => {
        const searchTerm = e.target.value.toLowerCase().trim();
        const list = e.target.closest('.collection-filter__body')?.querySelector('.collection-filter__list');
        if (!list) return;

        list.querySelectorAll('li').forEach((li) => {
          const label = li.querySelector('.collection-filter__option-label');
          if (!label) return;
          const text = label.textContent.toLowerCase();
          li.style.display = text.includes(searchTerm) ? '' : 'none';
        });
      });
    });

    // ── Auto-apply filters on change ───────────────────────
    const form = document.getElementById('SearchFiltersForm');
    form?.addEventListener('change', () => form.submit());
    form?.addEventListener('submit', (e) => { e.preventDefault(); form.submit(); });

    // ── Infinite scroll ────────────────────────────────────
    const grid = document.getElementById('SearchGrid');
    const sentinel = document.getElementById('SearchSentinel');
    const loading = document.getElementById('SearchLoading');
    const endMsg = document.getElementById('SearchEnd');

    if (!grid || !sentinel) return;

    let isFetching = false;

    const observer = new IntersectionObserver((entries) => {
      if (!entries[0].isIntersecting || isFetching) return;

      const nextUrl = grid.dataset.nextUrl;
      if (!nextUrl) {
        observer.disconnect();
        sentinel.remove();
        endMsg?.removeAttribute('aria-hidden');
        return;
      }

      isFetching = true;
      loading?.removeAttribute('aria-hidden');

      fetch(nextUrl)
        .then((r) => {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newItems = doc.querySelectorAll('.collection-grid__item');
          const newNextUrl = doc.getElementById('SearchGrid')?.dataset.nextUrl || '';

          newItems.forEach((item) => grid.appendChild(item));
          grid.dataset.nextUrl = newNextUrl;

          loading?.setAttribute('aria-hidden', 'true');
          isFetching = false;

          if (!newNextUrl) {
            observer.disconnect();
            sentinel.remove();
            endMsg?.removeAttribute('aria-hidden');
          }
        })
        .catch(() => {
          loading?.setAttribute('aria-hidden', 'true');
          isFetching = false;
        });
    }, { rootMargin: '300px' });

    observer.observe(sentinel);
  };

  document.addEventListener('DOMContentLoaded', initSearch);
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target.querySelector('.search-page')) initSearch();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stats"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const items = document.querySelectorAll('.stat-item');
    if (!items.length) return;

    function parseNumber(str) {
      return parseFloat(str.replace(/[^0-9.]/g, '')) || null;
    }

    function getSuffix(str) {
      return str.replace(/^[0-9.,\s]+/, '');
    }

    function getPrefix(str) {
      return str.match(/^[^0-9]*/)[0];
    }

    function formatNumber(val, original) {
      if (original.includes('.')) {
        return val.toFixed(1);
      }
      return Math.round(val).toLocaleString();
    }

    function animateStat(el) {
      const raw = el.dataset.statValue || '';
      const num = parseNumber(raw);
      if (!num) return;

      const numEl = el.querySelector('.stat-item__number');
      if (!numEl) return;

      const prefix = getPrefix(raw);
      const suffix = getSuffix(raw);
      const duration = 1800;
      const start = performance.now();

      function ease(t) {
        return 1 - Math.pow(1 - t, 3);
      }

      function step(now) {
        const elapsed = now - start;
        const progress = Math.min(elapsed / duration, 1);
        const current = ease(progress) * num;
        numEl.textContent = prefix + formatNumber(current, raw) + suffix;
        if (progress < 1) {
          requestAnimationFrame(step);
        } else {
          numEl.textContent = raw;
        }
      }

      requestAnimationFrame(step);
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animateStat(entry.target);
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.3 });

    items.forEach(item => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  class TestimonialsSlider {
    constructor(container) {
      if (!container) return;
      this.container = container;
      this.slides = container.querySelectorAll('.testimonials__slide');
      this.prevBtn = container.querySelector('[data-control="prev"]');
      this.nextBtn = container.querySelector('[data-control="next"]');
      this.currentIndex = 0;
      this.autoplay = container.dataset.autoplay === 'true';
      this.speed = parseInt(container.dataset.speed) || 5000;
      this.interval = null;

      if (this.slides.length <= 1) return;

      this.init();
    }

    init() {
      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', () => {
          this.stopAutoplay();
          this.goTo(this.currentIndex - 1);
        });
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', () => {
          this.stopAutoplay();
          this.goTo(this.currentIndex + 1);
        });
      }

      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.interval = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.speed);
    }

    stopAutoplay() {
      if (this.interval) clearInterval(this.interval);
    }

    goTo(index) {
      this.slides[this.currentIndex].classList.remove('is-active');
      
      if (index < 0) {
        this.currentIndex = this.slides.length - 1;
      } else if (index >= this.slides.length) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }

      this.slides[this.currentIndex].classList.add('is-active');
    }
  }

  const initTestimonials = () => {
    document.querySelectorAll('.testimonials').forEach(container => {
      new TestimonialsSlider(container);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initTestimonials);
  } else {
    initTestimonials();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.testimonials')) {
      new TestimonialsSlider(event.target.querySelector('.testimonials'));
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-slider"] && !Shopify.designMode) return;
  try {
    
  class TextSlider {
    constructor(container) {
      this.container = container;
      this.slides = container.querySelectorAll('.text-slider__slide');
      this.prevBtn = container.querySelector('[data-control="prev"]');
      this.nextBtn = container.querySelector('[data-control="next"]');
      this.currentIndex = 0;
      this.autoplay = container.dataset.autoplay === 'true';
      this.speed = parseInt(container.dataset.speed) || 5000;
      this.interval = null;

      if (this.slides.length <= 1) {
        if (this.prevBtn) this.prevBtn.hidden = true;
        if (this.nextBtn) this.nextBtn.hidden = true;
        return;
      }

      this.init();
    }

    init() {
      this.prevBtn.addEventListener('click', () => {
        this.stopAutoplay();
        this.goTo(this.currentIndex - 1);
      });

      this.nextBtn.addEventListener('click', () => {
        this.stopAutoplay();
        this.goTo(this.currentIndex + 1);
      });
      
      if (this.autoplay) {
        this.startAutoplay();
      }
    }

    startAutoplay() {
      this.interval = setInterval(() => {
        this.goTo(this.currentIndex + 1);
      }, this.speed);
    }

    stopAutoplay() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    goTo(index) {
      this.slides[this.currentIndex].classList.remove('is-active');
      
      if (index < 0) {
        this.currentIndex = this.slides.length - 1;
      } else if (index >= this.slides.length) {
        this.currentIndex = 0;
      } else {
        this.currentIndex = index;
      }

      this.slides[this.currentIndex].classList.add('is-active');
    }
  }

  // Initialize all sliders on the page
  const initTextSliders = () => {
    document.querySelectorAll('.text-slider').forEach(container => {
      new TextSlider(container);
    });
  };

  document.addEventListener('DOMContentLoaded', initTextSliders);

  // Theme Editor integration
  document.addEventListener('shopify:section:load', (event) => {
    if (event.target.querySelector('.text-slider')) {
      new TextSlider(event.target.querySelector('.text-slider'));
    }
  });

  } catch(e) { console.error(e); }
})();
})();
